export const DOC_MANAGER_IFRAME_NEW_REF = 'DOC_MANAGER_IFRAME_NEW_REF';
export const DOC_MANAGER_IFRAME_LOAD = 'DOC_MANAGER_IFRAME_LOAD';
export const DOC_MANAGER_IFRAME_READY = 'DOC_MANAGER_IFRAME_READY';
